import api from './api';

export const blogService = {
  createBlog: async (payload) => {
    const response = await api.post('/blogs', payload);
    return response.data;
  },

  getBlogs: async (params = {}) => {
    const response = await api.get('/blogs', { params });
    return response.data;
  },

  getBlogById: async (id) => {
    const response = await api.get(`/blogs/id/${id}`);
    return response.data;
  },

  getBlogBySlug: async (slug) => {
    const response = await api.get(`/blogs/${slug}`);
    return response.data;
  },

  updateBlog: async (id, payload) => {
    const response = await api.put(`/blogs/${id}`, payload);
    return response.data;
  },

  deleteBlog: async (id) => {
    const response = await api.delete(`/blogs/${id}`);
    return response.data;
  },

  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);

    const response = await api.post('/blogs/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },
};

